var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgNotification = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("circle", {
    cx: 53.785,
    cy: 74.088,
    r: 7.913,
    fill: "var(--color-neutral-70)",
    transform: "rotate(-16 53.785 74.088)"
  }), React.createElement("path", {
    fill: "var(--color-neutral-100)",
    d: "m47.014 76.03 13.522-3.878.485 1.69-13.523 3.877z"
  }), React.createElement("circle", {
    cx: 53.785,
    cy: 74.088,
    r: 7.163,
    stroke: borderColor,
    strokeWidth: 1.5,
    transform: "rotate(-16 53.785 74.088)"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M58.288 75.764s.017 1.48-1.85 2.47"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M26.05 48.916c-4.281-14.93 4.804-25.767 13.818-28.352 9.015-2.585 22.458 1.792 26.739 16.722 3.07 10.705 9.394 14.685 12.656 16.493 3.262 1.808 3.708 4.425 4.03 5.551.324 1.127.57 6.24-2.81 7.209l-25.345 7.267-25.354 7.27c-3.38.97-5.88-3.496-6.204-4.623-.323-1.127-1.332-3.581.477-6.844 1.808-3.262 5.063-9.988 1.993-20.693Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M30.59 64.077c.43-1.382.777-2.986.924-4.82.22-2.767-.015-6.059-1.118-9.904-2.267-7.907-.91-15.373 2.51-20.085.365-.505.746-.945 1.139-1.342"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M23.58 76.453c-.323-1.127-1.332-3.581.477-6.844l55.215-15.833c3.262 1.809 3.698 4.428 4.021 5.554.324 1.127.57 6.24-2.81 7.209l-50.7 14.537c-3.38.97-5.88-3.496-6.203-4.623Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m54.69 69.057 14.085-4.04M71.03 64.372l2.254-.646M75.538 63.079l2.253-.646"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M34.76 22.943c-1.357-4.733 1.964-6.965 3.654-7.45 1.69-.485 5.976-.433 7.333 4.3"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M67.505 28.25a6.42 6.42 0 1 1-12.341 3.54 6.42 6.42 0 0 1 12.341-3.54Z"
  }));
};
export default SvgNotification;